class Common{

    constructor(){
        this.leaderboardEndpoint = "/street-smart-trivia/leaderboard/";
        this.audioPath = '/site/assets/games/street-smart-trivia/audio/';
        this.assetsPath = '/site/assets/games/street-smart-trivia/assets/';
        // this.leaderboardEndpoint = "https://leaderboard:8890/leaderboard/";
        // this.audioPath = 'audio/';
        // this.assetsPath = 'assets/';
        this.gameScale = 4;
        this.font = 'pixelify';
        this.blue = '#2E4C73';
        this.dark = '#12202E';
        this.bgMusicVolume = 0.3;
        this.blipVolume = 0.5;
        this.popUpTweenChain = (targetHeight) => {
            return [
                {
                    y: targetHeight,
                    scaleY: 4.4,
                    scaleX: 3,
                    duration: 100,
                    ease: 'Power2'
                },
                {
                    scaleY: 4,
                    scaleX: 4,
                    duration: 150,
                    ease: 'Back.easeOut'
                }
            ]
        }
    }
}

export default Common;